<script setup lang="ts">
const props = defineProps<{
    title: string,
    desc: string,
    items: {
        title: string,
        groups: string[]
    }[]
}>();
</script>

<template>
    <SectionsBase id="why-navatel" class="background">
        <div class="container relative z-1">
            <ChipsDivider>چرا نواتل</ChipsDivider>
            <h2>{{ props.title }}</h2>
            <p class="text-body1-semibold text-gray-400 text-center mt-6 mb-10">{{ props.desc }}</p>

            <DevicesMobile>
                <div 
                    class="py-8 flex-center bg-gray-100 rounded-3xl mx-auto w-68.75"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                >
                    <h3>{{ props.items[0]?.title }}</h3>
                </div>
                <div class="w-full flex flex-col pt-22 relative">
                    <svg class="absolute top-4 left-2 w-1/2" viewBox="0 0 148 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M146 1.5C146 9.78319 139.285 16.498 131.002 16.498H25.5C12.2452 16.498 1.5 27.2432 1.5 40.498V47.6484" stroke="#CACFD9" stroke-width="3" stroke-linecap="round" stroke-linejoin="bevel"/>
                    </svg>
                    <SectionsWhyNavatelItems 
                        v-if="props.items[0]" 
                        type="first" 
                        :items="props.items[0]" 
                    />
                </div>
                <div 
                    class="py-8 flex-center bg-success-600 shadow-success-l text-white rounded-3xl w-68.75 mx-auto mt-10"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                >
                    <h3>{{ props.items[1]?.title }}</h3>
                </div>
                <div class="w-full flex flex-col pt-22 relative">
                    <svg class="absolute top-4 right-2 w-1/2" viewBox="0 0 148 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.5 1.5C1.5 9.78454 8.21595 16.5005 16.5005 16.5005H122C135.255 16.5005 146 27.2457 146 40.5005V47.6504" stroke="#CACFD9" stroke-width="3" stroke-linecap="round" stroke-linejoin="bevel"/>
                    </svg>
                    <SectionsWhyNavatelItems 
                        v-if="props.items[1]" 
                        type="second" 
                        :items="props.items[1]" 
                    />
                </div>
            </DevicesMobile>

            <DevicesDesktop>
                <div class="w-full flex-center gap-10 relative">
                    <IconsCurvedArrow class="absolute top-50 text-primary-500 scale-y-[-1] origin-top mr-5 z-1" />
                    <div class="py-8 flex-center bg-gray-100 rounded-3xl w-75">
                        <h3>{{ props.items[0]?.title }}</h3>
                    </div>
                    <div class="py-8 flex-center bg-success-600 shadow-success-l text-white rounded-3xl w-75">
                        <h3>{{ props.items[1]?.title }}</h3>
                    </div>
                </div>
                <div class="w-full flex justify-between gap-10 overflow-hidden">
                    <div class="w-full flex flex-col gap-3">
                        <SectionsWhyNavatelItems
                            v-if="props.items[0]" 
                            type="first" 
                            :items="props.items[0]"
                        />
                    </div>
                    <div class="w-full flex flex-col gap-3">
                        <SectionsWhyNavatelItems
                            v-if="props.items[1]" 
                            type="second"
                            :items="props.items[1]"
                        />
                    </div>
                </div>
            </DevicesDesktop>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
    @apply
    relative
}
.background::before {
    @apply
    content-[''] absolute w-full h-full top-0 left-0 bg-[url('/img/new/backgrounds/dot-01.webp')] opacity-50;
}
</style>